



















import { Vue, Component, Prop, PropSync } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import pageMixins from "@mixins/pageMixins";
import commonMixins from "@mixins/commonNewMixins";
import { service } from "@modules/newCommunity/setup";
import SearchBox from "@/components/SearchBox/formWrap.vue";
import { formtemplateGenerateQuestionnaire } from "@modules/newCommunity/pages/operationTools/api/questionnaire";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";

import customPaginationTable from "@components/Table/customPaginationTable.vue";
function getListQuery() {
  return {
    title: "",
    id: "",
  };
}

@Component({
  name: "surveyTemplateSelectDialog",
  components: { SearchBox, customPaginationTable },
})
export default class surveyTemplateSelectDialog extends mixins(commonMixins, pageMixins) {
  @PropSync("modalVisible", { type: Boolean }) visible!: Boolean;

  listQuery = getListQuery();

  searchBoxSetting = {
    inline: true,
    block: true,
    labelWidth: "112px",
    style: { width: "220px" },
  };
  searchBox = [
    {
      key: "title",
      type: "input",
      label: "模板名称：",
      placeHolder: "请输入模板名称",
      size: "small",
      style: { width: "220px" },
    },
    {
      key: "id",
      type: "input",
      label: "模板ID：",
      placeHolder: "请输入模板ID",
      size: "small",
      style: { width: "220px" },
    },
  ];
  private columns = [
    {
      type: "selection",
      width: "55px",
      fixed: true,
    },
    {
      label: "模版名称",
      prop: "title",
    },
    {
      label: "模版ID",
      prop: "id",
    },
  ];

  tableData = [];
  formatter = (row: any, column: any, cellValue: any) => {
    if (cellValue === 0 || cellValue === "0" || cellValue) {
      return cellValue;
    } else {
      return "-";
    }
  };

  onSearch() {
    this.pageParam.pageNum = 1;
    this.getTableData();
  }

  onReset() {
    this.pageParam.pageNum = 1;
    this.listQuery = getListQuery();
    this.getTableData();
  }

  onConditionChange() {
    this.getTableData();
  }

  getParmas() {
    let newParmas = JSON.parse(JSON.stringify(this.listQuery));
    return { ...newParmas, pageSize: this.pageParam.pageSize, pageNum: this.pageParam.pageNum, formProperty: this.questionnaireProperty };
  }
  loading = false;
  getTableData() {
    this.loading = true;
    const params = this.getParmas();
    service
      .questionnaireTemplateGetPageInfo(params)
      .then((res: any) => {
        this.tableData = res.data.rows || [];
        this.pageParam.total = res.data.total;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  created() {
    this.getTableData();
  }
  ////////////////////////
  multipleSelection: any = [];
  // handleSelectionChange(val: any) {
  //   this.multipleSelection = val;
  // }
  selectChange(selection: any) {
    if (selection.length > 1) {
      const del_row = selection.shift();
      (this.$refs.templateTable as any).toggleRowSelection(del_row, false);
    }
    // console.log("selectChange", selection);
    this.multipleSelection = selection;
  }
  get questionnaireProperty() {
    return QuestionnaireEditModule.questionnaireProperty;
  }
  /////////////

  private async handleConfirm() {
    if (this.multipleSelection.length > 0) {
      let checkRes = await service.questionnaireTemplateGetDetail({ id: this.multipleSelection[0].id, copy: true });
      // console.log("checkRes", checkRes);
      if (checkRes.code == 200 && checkRes.data.deleteStatus == 1) {
        let qsRes: any = await formtemplateGenerateQuestionnaire({ templateId: this.multipleSelection[0].id || "" });

        this.$emit("confirm", qsRes);
        this.visible = false;
      } else {
        this.$message({
          type: "error",
          message: "模板不存在， 请重新选择",
        });
      }
    } else {
      this.$message({
        type: "error",
        message: "请选择一个模板",
      });
    }
  }

  onOpen() {
    this.multipleSelection = [];
    this.onReset();
    // (this.$refs.templateTable as any).clearSelection();
  }
}
